<template>
    <div class="login-background">
        <div class="login-background2">
            <div style="position: absolute;left: 50%;transform: translate(-50%,-50%);top: 50%;width: 100%">
                <img :src="companyName == '刚峰'?'/img/header/GFlogo.png':'/img/login/logo.png'">
                <p class="ylPlatform">{{$store.state.userInfo.companyShortName||companyName+'互联网律所管理平台'}}</p>
            </div>
            <p style="color:#c7cdd4;font-size: 14px;position: absolute;bottom: 40px;text-align: center;width: 100%">
                技术支持：律蛙智能</p>
        </div>
        <div style="width: 65%;height: 100%;position: relative;display: inline-block">
            <div class="loginFrame">
                <p style="color:#c7cdd4;font-size: 26px;margin-top: 30px;">修改密码</p>
                <!--<div>-->
                    <!--<p class="inputTips">姓名 / Name</p>-->
                    <!--<Input prefix="ios-phone-portrait" v-model="fullName" placeholder="请输入您姓名" style="width: auto"/>-->
                <!--</div>-->
                <div>
                    <p class="inputTips">手机号码 / Phone number</p>
                    <Input prefix="ios-phone-portrait" v-model="phoneNumber" placeholder="请输入您的手机号码" style="width: auto"/>
                </div>
                <div class="verificationCode">
                    <p class="inputTips">验证码 / verification code</p>
                    <Input prefix="ios-barcode-outline" v-model="verificationCode" placeholder="请输入验证码" style="width: auto;"/>
                    <p class="obtainVerificationCode" @click="getMessage()" v-if="messageTimer.fun==null">获取验证码</p>
                    <p class="obtainVerificationCode" v-else>{{messageTimer.count+"s后重新获取"}}</p>
                </div>
                <div>
                    <p class="inputTips">密 码 / password</p>
                    <Input prefix="ios-unlock-outline" v-model="password" placeholder="请设置您的登录密码" style="width: auto" type="password"/>
                </div>
                <Button @click="register()" type="primary" style="width: 380px;height: 46px;border-radius: 22px;background-color: #00a2e9;font-size: 14px;margin-top: 32px;">
                    修改 / modify
                </Button>
                <div style="text-align: left;margin-left: 45px;margin-top: 18px;">
                    <p style="color:#464c5b;font-size: 14px;display: inline-block;">已经注册，
                        <router-link :to="{name:'login'}" class="register">去登录</router-link>
                    </p>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        name: "password",
        data() {
            return {
                messageTimer: {
                    fun: null,
                    count: '',
                },
                fullName: '',
                phoneNumber: '',
                verificationCode: '',
                password: '',
                checked: true,
                checked1: false,
            }
        },
        methods: {
            getMessage: function () {
                var _this = this
                _this.send({
                    headers:'U/UserCode',
                    data: {
                        PhoneNumber:_this.phoneNumber,
                    },
                    success: function () {
                        _this.setReciprocal()
                    }
                })
            },
            register:function(){
                var _this = this
                _this.send({
                    headers: "U/EditPassWord",
                    data: {
                        PhoneNumber: _this.phoneNumber,
                        Code: _this.verificationCode,
                        PassWord: _this.password,
                    },
                    success: function () {
                        _this.$Modal.success({
                            title:'系统消息',
                            content:'修改成功',
                        })
                        _this.login()
                    }
                })
            },
            login:function () {
                var _this = this
                _this.send({
                    headers:"U/Login",
                    data: {
                        Login:_this.phoneNumber,
                        PassWord:_this.password,
                    },
                    success: function (res) {
                        window.sessionStorage.userToken = res.UserToken
                        window.sessionStorage.phoneNumber = res.UserLogin
                        window.sessionStorage.groupId = res.GroupId
                        window.sessionStorage.userId = res.UserId
                        window.sessionStorage.fullName = res.UserName
                        window.sessionStorage.userIcon = res.UserImg
                        window.sessionStorage.companyShortName = res.GroupShortName
                        window.sessionStorage.groupName = res.PurviewName
                        window.sessionStorage.companyName = res.GroupName
                        SYSCONFIG.server.default.data.UserLogin = res.UserLogin
                        SYSCONFIG.server.default.data.UserToken = res.UserToken
                        SYSCONFIG.server.default.data.GroupId = res.GroupId
                        _this.$router.push({name:'home'})
                    }
                })
            },
            setReciprocal:function () {
                var _this = this
                var TIME_COUNT = 60
                if (!_this.messageTimer.fun) {
                    _this.messageTimer.count = TIME_COUNT
                    _this.messageTimer.fun = setInterval(function () {
                        if (_this.messageTimer.count > 0 && _this.messageTimer.count <= TIME_COUNT) {
                            _this.messageTimer.count--
                        } else {
                            clearInterval(_this.messageTimer.fun)
                            _this.messageTimer.fun = null;
                        }
                    }, 1000)
                }
            }
        }
    }
</script>

<style scoped>
    .login-background{background: url(/img/login/login-background.png) no-repeat;background-size: 100% 100%;position: fixed;width: 100%;max-width: 100%;height: 100%;z-index: 999;top: 0;font-size: 0;}
    .login-background2{background: url(/img/login/login-background2.png) no-repeat;background-size: 100% 100%;width: 35%;height: 100%;text-align: center;position: relative;display: inline-block;max-width: 640px;}
    .ylPlatform{font-size: 32px;color: #ffffff;margin-top: 35px;}
    .loginFrame{width: 460px;padding:40px 0;background-color: rgba(255,255,255,0.9);position: absolute;display: inline-block;left: 50%;transform: translate(-50%,-50%);top: 50%;text-align: center;}
    .inputTips{color:#707070;font-size: 14px;text-align: left;margin-left: 45px;margin-top: 25px;margin-bottom: 10px;}
    .loginFrame >>> .ivu-input{width: 380px;height: 46px;border-radius: 22px;font-size: 14px;color: #c7cdd4;padding-left: 45px;}
    .loginFrame >>> .ivu-input-prefix, .ivu-input-suffix{top: 6px;left: 10px;}
    .loginFrame >>> .ivu-input-prefix i, .ivu-input-suffix i{font-size: 22px;}
    .verificationCode{position: relative}
    .obtainVerificationCode{font-size: 14px;position: absolute;right: 60px;top: 43px;color: #00a2e9;cursor:pointer;}
    .verificationCode >>> .ivu-input{padding-right: 98px;}
    .register{color: #00a2e9;text-decoration:underline;display: inline-block;}
</style>
